import IdentifyFrontendCode from "../../../../contents/docs/_snippets/identify-frontend-code.mdx";
import * as React from 'react';
export default {
  IdentifyFrontendCode,
  React
};